import React from "react";
import { UseFormReturn } from "react-hook-form";

import { 
    Accordion, 
    AccordionDetails, 
    AccordionSummary, 
    Fab, 
    Grid, 
    IconButton, 
    List, 
    ListItem, 
    ListItemIcon, 
    ListItemText, 
    Stack, 
    Tooltip, 
    Typography, 
} from "@mui/material";

import { t, Trans } from "@lingui/macro";

import { AudioAndMusicDataProps, AudioAndMusicDataState } from "./models";

import { 
    MusicCueSheet 
} from "models";

import { ZPlayFormField } from "commons/fields";
import { RadioDefault } from "../radio-default/radio-default";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HelpIcon from '@mui/icons-material/Help';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import CircleIcon from '@mui/icons-material/Circle';
import ErrorIcon from '@mui/icons-material/Error';

export class AudioAndMusicData extends React.Component<AudioAndMusicDataProps & UseFormReturn, AudioAndMusicDataState> {

    constructor(props: any) {

        super(props);

        this.state = {
            checkMusic: this.props.getValues(`${this.props.name}.music`),
            error: false
        }
    }

    private updateValue = (value: boolean): void => {
        this.setState(() => ({
            checkMusic: value,
        }))
    }

    private addMusicData = (): void => {

        let musicCueSheet: MusicCueSheet = {
            title: this.props.getValues(`${this.props.name}.musicTitle`),
            code: this.props.getValues(`${this.props.name}.musicCode`),
            startTime: this.props.getValues(`${this.props.name}.musicCueIn`),
            endTime: this.props.getValues(`${this.props.name}.musicCueOut`),
            composers: this.props.getValues(`${this.props.name}.musicComposer`),
            publishers: this.props.getValues(`${this.props.name}.musicPublishers`),
            performers: this.props.getValues(`${this.props.name}.musicPerformers`),
            recordLabel: this.props.getValues(`${this.props.name}.recordLabel`),
        }

        let newMusicCueSheets = this.props.musicCueSheets.concat(musicCueSheet)

        this.props.updateMusicSheetData(newMusicCueSheets);
    }

    private deleteSong = (title: string) => {

        let newMusicCueSheets = this.props.musicCueSheets.filter(item => item.title !== title);

        this.props.updateMusicSheetData(newMusicCueSheets);
    }

    render() {
        return (
            <Accordion sx={{ backgroundColor: process.env.REACT_APP_THIRD_COLOR }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                        <Trans id={"df-audio-music-section"}>Audio e musica</Trans>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Typography color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                            <Trans id={"df-dialogue-label"}>Dialoghi</Trans>
                        </Typography>
                        <RadioDefault
                            {...this.props}
                            name={`${this.props.name}.dialogue`}
                            updateValue={() => ({})} />
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Typography color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                            <Trans id={"df-music-label"}>Musica</Trans>
                        </Typography>
                        <RadioDefault
                            {...this.props}
                            name={`${this.props.name}.music`}
                            defaultValue={false}
                            updateValue={this.updateValue} />
                    </Stack>
                    {this.state.checkMusic && <>
                        <List dense sx={{ display: `${this.props.musicCueSheets.length > 0 ? "block" : "none"}` }}>
                            {this.props.musicCueSheets.map((musicCueSheet, i) =>
                                <ListItem
                                    key={i}
                                    secondaryAction={
                                        <IconButton edge="end" aria-label="delete" onClick={() => { this.deleteSong(musicCueSheet.title) }}>
                                            <DeleteIcon fontSize="small" sx={{ color: process.env.REACT_APP_DEFAULT_TEXT_COLOR }} />
                                        </IconButton>
                                    }
                                >
                                    <ListItemIcon sx={{ minWidth: "35px" }}>
                                        <CircleIcon sx={{ width: "10px", height: "10px", color: process.env.REACT_APP_DEFAULT_TEXT_COLOR }} />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={
                                            <Stack direction="row" spacing={5}>
                                                <Typography
                                                    maxWidth={250}
                                                    color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}
                                                    sx={{
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                    }}>
                                                    {musicCueSheet.title} - <b>IN:</b>{musicCueSheet.startTime}	&lsquo; <b>OUT:</b>{musicCueSheet.endTime}	&lsquo;
                                                </Typography>
                                            </Stack>
                                        }
                                    />
                                </ListItem>
                            )}
                        </List>
                        <Typography color={process.env.REACT_APP_DEFAULT_TEXT_COLOR} mt={2}>
                            <Trans id={"df-music-cue-title"}>Elenco dei brani</Trans>
                        </Typography>
                        <Grid container columnSpacing={3}>
                            <Grid item xs={12} md={8}>
                                <ZPlayFormField
                                    label={t({
                                        id: "df-music-title",
                                        message: "Titolo"
                                    })}
                                    name={`${this.props.name}.musicTitle`}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <ZPlayFormField
                                    label={t({
                                        id: "df-music-code",
                                        message: "Codice"
                                    })}
                                    name={`${this.props.name}.musicCode`}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <ZPlayFormField
                                    label={t({
                                        id: "df-music-start-cue",
                                        message: "Minuto di inizio"
                                    })}
                                    name={`${this.props.name}.musicCueIn`}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <ZPlayFormField
                                    label={t({
                                        id: "df-music-end-cue",
                                        message: "Minuto di fine"
                                    })}
                                    name={`${this.props.name}.musicCueOut`}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <ZPlayFormField
                                    label={t({
                                        id: "df-music-composer",
                                        message: "Compositore"
                                    })}
                                    name={`${this.props.name}.musicComposer`}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <ZPlayFormField
                                    label={t({
                                        id: "df-music-publishers",
                                        message: "Direttore"
                                    })}
                                    name={`${this.props.name}.musicPublishers`}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <ZPlayFormField
                                    label={t({
                                        id: "df-music-performers",
                                        message: "Musicisti"
                                    })}
                                    name={`${this.props.name}.musicPerformers`}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <ZPlayFormField
                                    label={t({
                                        id: "df-music-record-label",
                                        message: "Etichetta discografica"
                                    })}
                                    name={`${this.props.name}.musicRecordLabel`}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                        </Grid>
                        <Stack direction="row" spacing={1} mt={1} mb={2}>
                            <HelpIcon fontSize="small" sx={{ color: process.env.REACT_APP_SECONDARY_TEXT_COLOR }} />
                            <Typography
                                variant={"body2"}
                                color={process.env.REACT_APP_SECONDARY_TEXT_COLOR}>
                                <Trans id={"df-music-cue-explanation"}>Inserisci i cue di inizio e fine in minuti. Se è presente più di un compositore, direttore o musicista inserisci i nomi separati da virgola.</Trans>
                            </Typography>
                        </Stack>
                        {this.state.error && <Stack direction="row" spacing={1} mb={2}>
                            <ErrorIcon fontSize="small" color="error" />
                            <Typography
                                variant={"body2"}
                                color="error">
                                <Trans id={"df-audio-and-music-data-section-error"}>È necessario inserire i punti di inizio e fine, titolo e codice del brano</Trans>
                            </Typography>
                        </Stack>}

                        <Tooltip title="Aggiungi brano" placement="right" sx={{ mt: 1 }}>
                            <Fab size="small" color="primary" onClick={this.addMusicData}>
                                <AddIcon />
                            </Fab>
                        </Tooltip>
                    </>}
                </AccordionDetails>
            </Accordion>)
    }
}